import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { TokenService } from '../services/token.service';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard  {
  constructor(private tokenService: TokenService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.tokenService.checkTokens().pipe(
      tap(response => {
        if (response) {
          this.router.navigateByUrl('day-list');
        }
      }),
      map(response => !response)
    );
  }
}
